import { USERS_SUBSCRIPTIONS_ENDPOINT } from "../api-services/ApiEndpoints";

export const getUsersWithSubscriptions = async (page = 1, limit = 20) => {
    const url = `${process.env.REACT_APP_API_URL}${USERS_SUBSCRIPTIONS_ENDPOINT}?page=${page}&limit=${limit}`;
    const token = localStorage.getItem('token');
    
    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`,
            'accept': 'application/json'
        }
    });
    
    if (!response.ok) {
        throw new Error(`Failed to fetch users with subscriptions: ${response.status}`);
    }
    
    return await response.json();
};
